export default __webpack_public_path__ + "static/media/medicine.a2a2b4f2.png";